export default {
  mounted() {
    this.$nextTick(() => {
      if (this.onlyRead) {
        this.result = this.onlyReadShowData || this.value
      }
    })
  }
}
